import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';

import './CheckIcon.scss';

const CheckIcon = ({ animate, stroke }) => {
  const CheckIconContainer = classes('check-icon', {
    animate,
  });

  return (
    <svg className={CheckIconContainer} width="14px" height="11px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Green checkmark</title>
      <defs />
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
        <g transform="translate(-965.000000, -553.000000)" id="Transfer-Ownership" stroke={stroke} strokeWidth="2">
          <g transform="translate(343.000000, 452.000000)">
            <g id="Transfer-Ownership---Selected" transform="translate(416.000000, 0.000000)">
              <g id="Dropdown---Open" transform="translate(0.000000, 32.000000)">
                <path d="M221,70 L211.666667,79.7777778 L221,70 Z M207,76.1111111 L211.666667,81 L207,76.1111111 Z" id="Check" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

CheckIcon.propTypes = {
  animate: PropTypes.bool,
  stroke: PropTypes.string,
};

CheckIcon.defaultProps = {
  animate: false,
  stroke: '#5AA831',
};

export default CheckIcon;
